import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useAddToCart } from '../../../hooks/use-add-to-cart.js';
import { AddButton } from '../components/AddButton.js';

const AddButtonContainer = ({ lineItemDrafts , onSuccess  })=>{
    const { getLabel  } = useIntl();
    const [addToCart, { loading  }] = useAddToCart();
    const labels = React.useMemo(()=>({
            addToCart: getLabel('cart.actions.addToCart')
        })
    , [
        getLabel
    ]);
    const handOnClick = React.useCallback(()=>addToCart(lineItemDrafts, onSuccess)
    , [
        lineItemDrafts,
        onSuccess
    ]);
    return /*#__PURE__*/ React.createElement(AddButton, {
        isLoading: loading,
        caption: labels.addToCart,
        onClick: handOnClick
    });
};

export { AddButtonContainer };
//# sourceMappingURL=AddButtonContainer.js.map
